import React from 'react';
import { IonIcon } from '@ionic/react';

export interface ProChipProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  icon?: string;
  /** Slightly taller tap target — used on the home quick-actions strip. */
  size?: 'default' | 'comfortable';
}

/**
 * Compact pill button for Pro filter bars and quick actions.
 * Plain button (not IonChip) so icon + label stay vertically centered
 * without Ionic shadow-DOM padding fighting our layout.
 */
const ProChip: React.FC<ProChipProps> = ({
  children,
  onClick,
  className = '',
  icon,
  size = 'default',
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`pro-chip inline-flex items-center justify-center gap-1 shrink-0 rounded-full px-2.5 text-xs font-medium leading-none touch-manipulation active:scale-[0.98] ${
      size === 'comfortable' ? 'py-1.5' : 'py-1'
    } ${className}`.trim()}
  >
    {icon && (
      <IonIcon
        icon={icon}
        aria-hidden="true"
        className="pro-chip-icon shrink-0"
        style={{ fontSize: 14, width: 14, height: 14, margin: 0 }}
      />
    )}
    <span className="leading-none">{children}</span>
  </button>
);

export default ProChip;
